import { FC } from 'react';
import { ThemeProvider } from 'styled-components';

import { PortalTheme } from '@calm-web/design-system';

import HeroText from './HeroText';
import PlanPreview from './PlanPreview';
import { ContentWrapper, Wrapper } from './styles';
import TeamsNav from './TeamsNav';
import { TeamsHeroProps } from './types';

const TeamsHero: FC<TeamsHeroProps> = ({
	activePage,
	coveredLives,
	navigateTo,
	completedStep1,
	completedStep2,
}) => {
	const isPaymentPage = activePage === '#payment';
	const isCoveredLivesPage = activePage === '#coveredLives';
	const shouldShowPlanPreview = !isPaymentPage && !isCoveredLivesPage;
	return (
		<Wrapper role="banner" isPaymentPage={isPaymentPage}>
			<ContentWrapper>
				<TeamsNav
					activePage={activePage}
					navigateTo={navigateTo}
					completedStep1={completedStep1}
					completedStep2={completedStep2}
				/>
				{shouldShowPlanPreview && (
					<ThemeProvider theme={PortalTheme}>
						<PlanPreview
							activePage={activePage}
							coveredLives={coveredLives}
							displayPrice
							navigateTo={navigateTo}
						/>
					</ThemeProvider>
				)}
				{!isPaymentPage && <HeroText activePage={activePage} />}
			</ContentWrapper>
		</Wrapper>
	);
};

export default TeamsHero;
